import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import DropDown from "./DropDown";
import { Typography, Paper, styled, Button } from "@mui/material";
import { IMAGE_URL } from "config";
import PauseCircleFilledIcon from '@mui/icons-material/PauseCircleFilled';
const MyComponent = styled(Paper)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  padding: "2px 8px",
  gap: "10px",
  width: "148px",
  height: "24px",
  background: "#7B49E5",
  borderRadius: "6px",
  boxShadow: "none",
  flex: "none",
  order: 0,
  flexGrow: 0,
});

const LabelTypography = styled(Typography)({
  height: "20px",
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: "400",
  fontSize: "14px",
  lineHeight: "20px",
  color: "#FFFFFF",
});

const HeadingTypo = styled(Typography)({
  textAlign: "start",
  height: "36px",
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "24px",
  lineHeight: "150%",
  letterSpacing: " 0.01em",
  color: "#000000",
});

const SubTitle = styled(Typography)({
  height: "20px",
  textAlign: "start",
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  color: "#9EA3AE",
});

const DateTypo = styled(Typography)({
  height: "26px",
  fontFamily: "Outfit",
  textAlign: "start",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "160%",
  letterSpacing: "0.015em",
  color: "#9EA3AE",
  marginTop: "20px",
});

const SubsChipColor = {
  "fitness-subscription": {
    label: "Fitness subscription",
    color: "#FF8D85",
  },
  "personal-subscription": {
    label: "Personal subscription",
    color: "#7B49E5",
  },
  "multiple-subscription": {
    label: "Multiple subscription",
    color: "#158FAD",
  },
  "dietary-subscription": {
    label: "Dietary Subscription",
    color: "#FF8D85",
  },
  "bussines-subscription": {
    label: "Bussines subscription",
    color: "#FF9933",
  },
  "single-order": { label: "Single order", color: "#7ECC49" },
  "on-progress": { label: "On Progress", color: "#FAA641" },
  cooked: { label: "Cooked", color: "#42C677" },
  packed: { label: "Packed", color: "#42C677" },
};

const CustomCard = ({
  data,
  simpleCard,
  hasEditButton = false,
  hasActionButton = true,
  // handleChange,
  onEditClick,
  id
}) => {

  // console.log("handleChange", handleChange)
  return (
    <React.Fragment>
      <CardContent style={{ border: "0px", paddingLeft: "0px" }}>
        <Box style={{ display: "flex" }}>
          <Box>
            <img
              src={IMAGE_URL + data.img}
              alt={"subscription image"}
              loading="lazy"
              height="100%"
              style={{
                height: "141.4px",
                borderRadius: "4px",
                // width: "50%",
                // border:"1px solid red"
              }}
            />
          </Box>
          <Box style={{ marginLeft: 30, width: "100%" }}>
            <Box
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              {!simpleCard && (
                <>
                  <MyComponent
                    style={{
                      backgroundColor:
                        SubsChipColor["personal-subscription"].color,
                    }}
                  >
                    <LabelTypography>
                      {SubsChipColor["personal-subscription"].label}
                    </LabelTypography>
                  </MyComponent>
                  {hasActionButton && (
                    <DropDown
                      value="pause-subscription"
                      items={[
                        {
                          label: "View Details",
                          icon: "fa fa-eye",
                          id: "view-details",
                        },
                        {
                          label: "Pause Subscription",
                          icon: "fa fa-eye",
                          color: "#6A82CF",
                          id: "pause-subscription",
                        },
                        {
                          label: "Change Address",
                          icon: "fa fa-eye",
                          id: "change-address",
                        },
                        {
                          label: "View Receipt",
                          icon: "fa fa-eye",
                          id: "view-receipt",
                        },
                        {
                          label: "Cancel Subscription",
                          icon: "fa fa-eye",
                          color: "#E75C62",
                          id: "cancel-subscription",
                        },
                        { label: "Help", icon: "fa fa-eye", id: "help" },
                      ]}
                      id={id}
                      onClick={(e) => {
                        console.log(e);
                      }}
                    />
                  )}
                </>
              )}
            </Box>
            <Box
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
                // border: "1px solid red"
              }}
            >
              <Box>
                <Box>
                  {simpleCard ? (<HeadingTypo>{data?.heading}</HeadingTypo>) : (<HeadingTypo>{data?.mealPlan?.map((meal) => meal?.name)}</HeadingTypo>)}
                </Box>
                <Box>

                  {simpleCard && (<SubTitle>{data?.address}</SubTitle>)}
                </Box>
              </Box>

              {hasEditButton && (
                <Button
                  variant="outlined"
                  style={{
                    border: "1px solid #2B817B",
                    color: "#2B817B",
                    width: "120px",
                    maxHeight: "40px"
                  }}
                  onClick={onEditClick}
                >
                  Edit
                </Button>
              )}

              {data && data.status === "pause" && <Box >
                <Typography sx={{
                  color: "#E75C62", fontWeight: "bold",
                  // font-family: Outfit;
                  // font-size: 16px;
                  fontWeight: 400,
                  // line-height: 26px;
                  letterSpacing: "0.015em",
                  // text-align: left;
                  display: "flex",
                }}>
                  <PauseCircleFilledIcon sx={{ mr: 1 }} /> Paused untill {new Intl.DateTimeFormat('en-US', { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(data?.pause?.to))}
                </Typography>
              </Box>}
            </Box>
            <SubTitle>
              {!simpleCard && (
                <i class="fa fa-user" style={{ marginRight: "10px" }}></i>
              )}
              {data?.caterer?.map((caterer) => caterer?.merchantName)}
            </SubTitle>
            {!simpleCard && (
              <DateTypo>
                <i class="fa fa-calendar" style={{ marginRight: "10px" }}></i>
                {data?.startDate?.slice(5, 10) + "-" + data?.endDate?.slice(0, 10)}
              </DateTypo>
            )}
          </Box>
        </Box>
      </CardContent>
    </React.Fragment >
  );
};

export default function OutlinedCard({
  data,
  simpleCard,
  hasEditButton,
  hasActionButton,
  onEditClick,
  id
  // handleChange,
}) {
  console.log("data", data)

  return (
    <Box sx={{ minWidth: 275 }}>
      <Card variant="outlined" style={{ border: "0" }}>
        <CustomCard
          data={data}
          simpleCard={simpleCard}
          hasEditButton={hasEditButton}
          onEditClick={onEditClick}
          hasActionButton={hasActionButton}
          id={id}
        // handleChange={handleChange}
        />
      </Card>
    </Box>
  );
}
